import React, { useState } from "react";
import Header from "../../../Components/Header/Header";
import Footer from "../../../Components/Footer/Footer";
import "../DeleteScreen/DeleteScreen.css";
import { APIUrl, APIUrlToken, getIsUser } from "../../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { Box, Button, Modal } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const DeleteScreen = () => {
    const { logout } = useAuth0();
    const userLoginDetails = getIsUser();
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const handleRemoveAccount = () => {
        const url = `${APIUrl()}/v1/local/auth/users/${userLoginDetails?.user_id}`;
        const option = {
            method: "DELETE",
            headers: {
                "X-API-Key": APIUrlToken(),
            },
            url: url,
        };

        axios(option)
            .then((response) => {
                toast.success("Your account has been successfully removed.")
                localStorage.clear()
                logout({ logoutParams: { returnTo: window.location.origin } });
                navigate("/")
            })
            .catch((error) => {
                console.error("Error fetching teams data:", error);
            });
    }
    return (
        <>
            <Header />
            <div className="page-main-container-aboutus">
                <div className="content-section-changepass">
                    <h3>Delete Account</h3>

                    <div className="profile-container-deleteacc">
                        <div className="profile-card-deleteacc">
                            <p className="headline-deleteacc">
                                The account and its related information will be deleted. To continue, please select “Remove Account”.
                            </p>
                            <div className="button-section-deleteacc">
                                <button onClick={() => setOpen(true)}>Remove Account</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal open={open} onClose={() => setOpen(false)}>
                <div className="modal-container">
                    <Box sx={{
                        width: 400, p: 3, bgcolor: "white", borderRadius: 2, position: "relative",

                    }}>
                        <IoClose
                            className="close-icon"
                            size={24}
                            onClick={() => setOpen(false)}
                            style={{ position: "absolute", top: 10, right: 10, cursor: "pointer" }}
                        />
                        <h3 className="remove-acc-dltpage">Are you sure you want to remove your account?</h3>

                        <div className="buttons-cards-modal">
                            <Button className="submit-modal-card" onClick={handleRemoveAccount}>
                                Submit
                            </Button>
                            <Button className="cancel-button-modal" onClick={() => setOpen(false)}>
                                Cancel
                            </Button>
                        </div>
                    </Box>
                </div>
            </Modal >
            <Footer />
        </>
    );
};

export default DeleteScreen;
